import { render, staticRenderFns } from "./accountEdit.vue?vue&type=template&id=612438d2&scoped=true&lang=html&"
import script from "./accountEdit.vue?vue&type=script&lang=js&"
export * from "./accountEdit.vue?vue&type=script&lang=js&"
import style0 from "./accountEdit.vue?vue&type=style&index=0&id=612438d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612438d2",
  null
  
)

export default component.exports